import { ArrowRight } from "lucide-react";
import { AssetImage } from "./AssetImage";
import { FullscreenButton } from "./FullscreenButton";

interface TitleScreenProps {
  onStart: () => void;
}

// 标题页只承担 PPT 开场：书名、一句导语和开始按钮。AI 模式改在设置里选择。
export function TitleScreen({ onStart }: TitleScreenProps) {
  return (
    <main className="title-screen">
      <div className="title-screen__art" aria-hidden="true">
        <AssetImage assetId="1A-01" className="title-screen__art-desktop" alt="" eager sizes="100vw" />
        <AssetImage assetId="1A-02" className="title-screen__art-mobile" alt="" eager sizes="100vw" />
      </div>
      <FullscreenButton className="title-screen__fullscreen hud__tool" />
      <div className="title-screen__content">
        <h1>大自然的语言</h1>
        <p>成为少年物候观察员，读懂花木、候鸟与农时。</p>
        <button className="start-button" type="button" onClick={onStart}>
          开始观察 <ArrowRight size={20} />
        </button>
      </div>
    </main>
  );
}
